import "./index.css";
import FlowNumbersBox from "../FlowNumbersBox";
import SystemBoundary from "../HeaderBox/SystemBoundary";
const SubHeaderBox = ({
  subTitle,
  scope,
  subDescription,
  isNormal,
  number,
  systemBoundaryProps,
  showSystemBoundary,
  icon,
  customStyle,
}) => {
  return (
    <div
      className="subheader-box"
      style={{
        display: "flex",
        ...(!showSystemBoundary && { alignItems: "center" }),
        ...(customStyle && customStyle),
      }}
    >
      {icon && (
        <div style={{ marginRight: "20px" }}>
          <img src={icon} alt="Subgroup Icon" width={60} height={60} />
        </div>
      )}
      <div style={{ width: "100%" }}>
        <h5 style={{ margin: 0, marginBottom: "5px", fontWeight: "bold" }}>
          {subTitle}
        </h5>
        {scope && (
          <p
            style={{
              color: "#d7e1d9",
              padding: 0,
            }}
          >
            {scope}
          </p>
        )}
        <p style={{ padding: 0, marginBottom: 0 }}>{subDescription}</p>
        {showSystemBoundary && <SystemBoundary {...systemBoundaryProps} />}
      </div>

      {number && (
        <div
          style={{
            position: "absolute",
            bottom: "3px",
            right: "30px",
            paddingBottom: "5px",
          }}
        >
          <FlowNumbersBox isNormal={isNormal} number={number} />
        </div>
      )}
    </div>
  );
};

export default SubHeaderBox;
